module.exports = __webpack_public_path__ + "img/masks-theater.fc2c2fb4.svg";